import { Room } from '@webrtc/lib/Room'
import * as icons from '../Icons'
import { Button } from './Button'

export function VideoButton(props: {
  media: MediaStream
  waitingMedia: MediaStream
  room: Room
  showWaiting: boolean
  setShowWaiting: (b: boolean) => void
}) {
  const { setShowWaiting, showWaiting, media, waitingMedia, room } = props
  const onClick = () => {
    if (!showWaiting) {
      room.replaceTrack(
        media.getVideoTracks()[0],
        waitingMedia.getVideoTracks()[0]
      )
      setShowWaiting(true)
    } else {
      room.replaceTrack(
        waitingMedia.getVideoTracks()[0],
        media.getVideoTracks()[0]
      )
      setShowWaiting(false)
    }
  }
  return (
    <Button onClick={onClick}>
      {showWaiting ? icons.VidOff(32) : icons.VidOn(32)}
    </Button>
  )
}
